// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f5","border":"f6"};